import { useMemo } from "react";
import { useAuth } from "../auth/AuthContext";
import { BaseClient } from "../api/client";

/**
 * Factory hook that creates a BaseClient wired to the current auth context.
 * Returns null if the user is not yet authenticated.
 */
export function useApiClient(): BaseClient | null {
  const { token, refreshToken, logout, isAuthenticated } = useAuth();

  return useMemo(() => {
    if (!isAuthenticated || !token) return null;
    return new BaseClient(
      () => token,
      refreshToken,
      () => logout(),
    );
  }, [token, refreshToken, logout, isAuthenticated]);
}
